import { render } from "./CasinoLiveComponent.vue?vue&type=template&id=7168c31d&ts=true"
import script from "./CasinoLiveComponent.vue?vue&type=script&lang=ts"
export * from "./CasinoLiveComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__